;(function() {
/* @ngInject */
function CheckboxController() {
    let vm = this;
}

angular.module("firmaren")
    .component("checkbox", {
        templateUrl: "/app/shared/checkbox/checkbox.html",
        controller: CheckboxController,
        controllerAs: "vm",
        bindings: {
            model: "=",
            label: "@",
            tooltip: "@",
            error: "<"
        }
    });
}());
